export interface IB2CNotification {
  generationTaskId: number;
  notificationPriority: NotificationPriority;
  deliveryChannelTypes: DeliveryChannel[];
  subject: string;
  description: string;
  attachmentFile?: string;
}

export enum NotificationPriority {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export enum DeliveryChannel {
  Email = 'Email',
  Sms = 'Sms',
  VivicaNotifications = 'VivicaNotifications',
}

export interface CountOfOrderingProviders {
  numberOfOrderingProvidersToNotify: number;
}

export interface IB2CPreview {
  creatorFirstName: string;
  creatorMiddleName: string;
  creatorLastName: string;
  creatorCompanyName: string;
  creatorCompanyAddress: string;
}
